export const required = {
  required: true,
}

export const emailValidation = {
  type: 'email',
}
